import { OwnershipValueType } from "../components/ownership-select/ownership-value-type";
import { OwnershipPermissionType } from "./ownership-permission";

export class Ownership {
  public id: string;
  public parentId: string;
  public parentClass: string;
  public owner: string;
  public ownerName: string;
  public visibleTo: OwnershipValueType = OwnershipValueType.All;
  public editableFor: OwnershipValueType = OwnershipValueType.Custom;
  public permission: OwnershipPermissionType;

}
